import useMutation from "src/hooks/useMutation";

function useCustomerCreate() {
  return useMutation({
    path: `/api/v1/customers`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomerCreate;
